import { ReducerAction } from '../ReducerAction';
import { ActionType } from '../ActionsTypes';
import { ModalSaleSetup, ModalStep } from '../states/SaleState';
import { getSkuDetailUseCase, getSkuDetailAfterActivationUseCase, sellUseCase } from '../../../di/usecase_module';
import { SkuProcessEngine } from '../../../componentes/sku/utils/SkuProcessEngine';
import { GetSkuDetailRequestDto } from '../../../domain/usecases/sku/GetSkuDetailUseCase';
import { GetSkuDetailAfterActivationRequestDto } from '../../../domain/usecases/sku/GetSkuDetailAfterActivationUseCase';
import { handleError } from '../../utils/handleError';
import { Sku } from '../../../domain/models/Sku';
import { RequestParam } from '../../../domain/models/RequestParam';
import { SkuDetailSection, SkuDetail } from '../../../domain/models/SkuDetail';
import { BalanceActions } from './BalanceActions';
import { applog } from '../../../domain/utils/applog';


export class SaleActions {
    static reset(): ReducerAction { return { type: ActionType.SALE_RESET } }

    static prevStep(actualStep: number, actualModalStep: ModalStep) {
        return (dispatch: any) => {
            if (actualStep === 0 && actualModalStep === ModalStep.SKU_SALE) {
                dispatch({ type: ActionType.SALE_RETURN_TO_OPTIONS });
                return;
            } else if (actualStep === 0 && actualModalStep === ModalStep.SELECT_SKU) {
                dispatch(SaleActions.reset());
                dispatch(SaleActions.close());
                return;
            } else if (actualModalStep === ModalStep.CONFIRM) {
                dispatch({ type: ActionType.SALE_SET_MODAL_STEP, payload: ModalStep.SKU_SALE });
                return;
            }
            dispatch({ type: ActionType.SALE_PREVIOUS })
        }

    }

    static open(setup: ModalSaleSetup) {
        return {
            type: ActionType.SALE_OPEN,
            payload: setup
        }
    }
    static close() {
        return {
            type: ActionType.SALE_CLOSE
        }
    }

    static nextStep(actualStep: number, sections: SkuDetailSection[], params: RequestParam[], pos: string, token: string) {

        applog('SALE NEXT', actualStep, params);
        return (dispatch: any) => {
            if (actualStep < (sections.length - 1)) {
                dispatch(SaleActions.addParams(params))
                dispatch({ type: ActionType.SALE_NEXT });
            } else {
                dispatch(SaleActions.addParams(params))
                dispatch({ type: ActionType.SALE_SHOW_CONFIRM });
            }
        }
    }
    static setSku(sku: Sku): ReducerAction {
        return {
            type: ActionType.SALE_SET_SKU,
            payload: sku
        }
    }

    // [Balance Step 6]: Acción para guardar mensaje
    static setClientBalance(balance: string): ReducerAction {
        return {
            type: ActionType.SALE_SET_CLIENT_BALANCE,
            payload: balance
        }
    }

    static loadingBalance = () => ({
        type: ActionType.SALE_LOADING_BALANCE
    });

    static loadingInactiveBalance = () => ({
        type: ActionType.SALE_LOADING_INACTIVE_BALANCE
    })

    static setSkuDetail(skuDetail: SkuDetail): ReducerAction {
        return {
            type: ActionType.SALE_SET_SKU_DETAIL,
            payload: skuDetail
        }
    }

    static setElementsInBody(elements: SkuDetailSection[]) {
        return {
            type: ActionType.SALE_SET_ELEMENTS_IN_BODY,
            payload: elements
        }
    }

    static showLoader(message?: string) {
        return {
            type: ActionType.SALE_SHOW_LOADING,
            payload: message
        }

    }
    static hideLoader() {
        return {
            type: ActionType.SALE_HIDE_LOADING,
        }
    }

    static selectSku(sku: Sku) {
        return (dispatch: any) => {
            dispatch(SaleActions.setSku(sku));
            dispatch(SaleActions.showLoader("Obteniendo proceso..."));

            getSkuDetailUseCase().execute(new GetSkuDetailRequestDto(sku.sku)).then((result) => {
                dispatch(SaleActions.setSkuDetail(result));

                const filteredElements = (result?.elements ?? []).filter(
                    el => !(el.param === "clientBalance" && el.webComponent === "input-client-balance")
                );

                dispatch(SaleActions.setElementsInBody(
                    SkuProcessEngine.getBodyElements(filteredElements)
                ));

                dispatch(SaleActions.addParams(
                    SkuProcessEngine.getHiddenParams(result?.elements ?? [])
                ));

                dispatch(SaleActions.hideLoader());
            }).catch((e) => {
                dispatch(SaleActions.hideLoader());
                handleError(e);
            });
        }
    }

    static processActivationQR(sku: string, token: string, ref: string) {
        return (dispatch: any) => {
            dispatch(SaleActions.showLoader("Procesando código QR..."));

            getSkuDetailAfterActivationUseCase().execute(
                new GetSkuDetailAfterActivationRequestDto(sku, token, ref)
            ).then((result) => {
                dispatch(SaleActions.setSkuDetail(result));
                
                const filteredElements = (result?.elements ?? []).filter(
                    el => !(el.param === "clientBalance" && el.webComponent === "input-client-balance")
                );

                dispatch(SaleActions.setElementsInBody(
                    SkuProcessEngine.getBodyElements(filteredElements)
                ));

                dispatch(SaleActions.addParams(
                    SkuProcessEngine.getHiddenParams(result?.elements ?? [])
                ));

                dispatch(SaleActions.hideLoader());
            }).catch((error) => {
                dispatch(SaleActions.hideLoader());
                handleError(error);
            });
        }
    }


    static addParams(params: RequestParam[]): ReducerAction {
        return {
            type: ActionType.SALE_ADD_PARAMS,
            payload: params
        }
    }
    static setParams(params: RequestParam[]): ReducerAction {
        return {
            type: ActionType.SALE_SET_PARAMS,
            payload: params
        }
    }


    static processPayment(params: RequestParam[], pos: string, token: string) {
        return (dispatch: any) => {
            dispatch(SaleActions.showLoader("Procesando el pago..."));

            sellUseCase().execute(params)
                .then((result) => {
                    dispatch(SaleActions.hideLoader());
                    dispatch(SaleActions.showResult(result));
                    dispatch(BalanceActions.updateBalance(token));

                }).catch((error) => {
                    dispatch(BalanceActions.updateBalance(token));
                    dispatch(SaleActions.hideLoader());
                    dispatch(SaleActions.reset());
                    dispatch(SaleActions.close());
                    handleError(error);
                })
        }
    }

    static processActivationPayment(params: RequestParam[], currentSku: string, pos: string, token: string) {
        return (dispatch: any) => {
            dispatch(SaleActions.showLoader("Procesando activación..."));

            sellUseCase().execute(params)
                .then((result) => {
                    const refParam = params.find(p => p.name === 'ref');
                    if (!refParam) {
                        throw new Error('Parámetro ref no encontrado');
                    }

                    getSkuDetailAfterActivationUseCase().execute(
                        new GetSkuDetailAfterActivationRequestDto(currentSku, token, refParam.value)
                    )
                        .then((secondResult) => {
                            dispatch(SaleActions.hideLoader());
                            dispatch(SaleActions.showResult(secondResult));
                            dispatch(BalanceActions.updateBalance(token));
                        })
                        .catch((secondError) => {
                            dispatch(BalanceActions.updateBalance(token));
                            dispatch(SaleActions.hideLoader());
                            dispatch(SaleActions.reset());
                            dispatch(SaleActions.close());
                            handleError(secondError);
                        });
                })
                .catch((error) => {
                    dispatch(BalanceActions.updateBalance(token));
                    dispatch(SaleActions.hideLoader());
                    dispatch(SaleActions.reset());
                    dispatch(SaleActions.close());
                    handleError(error);
                });
        }
    }
    static showResult(result: SkuDetail) {
        return {
            type: ActionType.SALE_SET_RESULT,
            payload: result
        }
    }

    static showTicketFailed() {
        return {
            type: ActionType.SALE_SHOW_TICKET_FAILED
        };
    }

    static hideTicketFailed() {
        return {
            type: ActionType.SALE_HIDE_TICKET_FAILED
        }
    }


}